import editShiftErrorModal from '../edit-shift-status-modals/edit-error-modal.html';
import editShiftErrorModalCtrl from '../edit-shift-status-modals/edit-error-modal.ctrl';
import editShiftSuccessModal from '../edit-shift-status-modals/edit-success-modal.html';
import editShiftSuccessModalCtrl from '../edit-shift-status-modals/edit-success-modal.ctrl';
import moment from 'moment-timezone';
import { ScheduleType } from '../../../databaseEnums';

class ExtendAssignmentModalController {
  /* @ngInject */
  constructor ($mdDialog, $window, $scope, Jobs, user, userJobs, timezone) {
    this.$mdDialog = $mdDialog;
    this.$window = $window;
    this.Jobs = Jobs;
    this.timezone = timezone;
    this.user = user;
    this.userJobs = userJobs;
    this.$scope = $scope;
  }

  showModifySuccessModal = ({ job }) => {
    const parentEl = document.body;
    const userName = this.user.fullname;
    const shift = job.jobShiftsCount > 1 ? 'shifts' : 'shift';
    return this.$mdDialog.show({
      parent: parentEl,
      fullscreen: true,
      template: editShiftSuccessModal,
      locals: {
        title: 'Assignment updated',
        bodyText: `You have updated ${job.jobShiftsCount} ${shift} for ${userName}.`
      },
      controller: editShiftSuccessModalCtrl,
      controllerAs: 's',
    });
  }

  showErrorModal = () => {
    const parentEl = document.body;
    return this.$mdDialog.show({
      parent: parentEl,
      fullscreen: true,
      template: editShiftErrorModal,
      controller: editShiftErrorModalCtrl,
      controllerAs: 'e',
    });
  }

  addShiftsRedirect = ({ externalUserId, positionId, startDate, endDate, job }) => {
    const reactAppUrl = this.$scope.$parent.app.reactAppUrl;
    let url = `${reactAppUrl}/jobs/post?directInviteUserIds="${externalUserId}"&position=${positionId}`;

    const startShiftDate = moment.tz(startDate, this.timezone).format("MM-DD-YYYY");
    const endShiftDate = moment.tz(endDate, this.timezone).format("MM-DD-YYYY");
    url += `&startShiftDate=${startShiftDate}&endShiftDate=${endShiftDate}`;

    const startTime = moment
      .tz(startDate, this.timezone)
      .format("HH:mm");
    const endTime = moment
      .tz(endDate, this.timezone)
      .format("HH:mm");
    url += `&startTime=${startTime}&endTime=${endTime}`;
    const singleShift = startDate.diff(endDate, 'days') === 0;
    url += `&scheduleType=${singleShift ? ScheduleType.SINGLE_SHIFT : ScheduleType.REPEATING}`;
    url += `&singleAssignmentView=true`;
    if (singleShift) {
      // This allows direct invites to correctly set shift
      // date when bulk single shift is enabled
      url += `&shiftDate=${startShiftDate}`;
    } else {
      url += `&scheduleId=${job.scheduleId}`;
    }
    this.$window.location.href = url;
  }


  onExtendAssignment = ({ job, endDate }) => {
    const jobId = job.jobId;
    const workerId = this.user.id;
    const oldEndDate = moment.tz(job.end_date_time, this.timezone);
    const newEndDate = moment.tz(endDate, this.timezone);
    const newDateAfterOldDate = newEndDate.isAfter(oldEndDate);
    if (newDateAfterOldDate) {
      const jobStartMinute = moment.tz(job.start_date_time, this.timezone).get('minute');
      const jobStartHour = moment.tz(job.start_date_time, this.timezone).get('hour');
      const jobEndMinute = moment.tz(job.end_date_time, this.timezone).get('minute');
      const jobEndHour = moment.tz(job.end_date_time, this.timezone).get('hour');

      const newStartDate =
        moment.tz(oldEndDate, this.timezone).add(1, 'days')
        .set({'hour': jobStartHour, 'minute': jobStartMinute, 'second': 0});
      const newEndDate2 = newEndDate
        .set({'hour': jobEndHour, 'minute': jobEndMinute, 'second': 0});

      this.addShiftsRedirect({
        externalUserId: this.user.external_id,
        positionId: job.positionId,
        startDate: newStartDate,
        endDate: newEndDate2,
        job,
      });
    } else {
      const newEndDateMilliseconds = moment.tz(endDate, this.timezone).valueOf();
      this.Jobs.changeAssignmentDateRange({
        jobId,
        workerId,
        endDate: newEndDateMilliseconds,
      })
        .then(() => {
          this.showModifySuccessModal({ job });
          // Refresh the page to get new roster shifts info
          this.$window.location.reload();
        })
        .catch((error) => error && this.showErrorModal());
    }
  }

  onClose = () => {
    this.$mdDialog.cancel();
  }
}

export default ExtendAssignmentModalController;
